<template>
    <div style="margin:3vw 35%">
        <el-form :model="postFrom" ref="postForm" :rules="rules">
            <el-form-item label="姓名:" prop="username">
                <el-input v-model="postFrom.username" placeholder="请输入姓名"/>
            </el-form-item>
            <el-form-item label="手机号:" prop="phone">
                <el-input v-model="postFrom.phone" placeholder="电话是与您联系的重要方式"/>
            </el-form-item>
            <el-form-item label="微信:">
                <el-input v-model="postFrom.wechat" placeholder="请确认微信号，不喜欢被电话骚扰，请优先微信联系"/>
            </el-form-item>
            <el-form-item label="投资额度:">
                <el-select v-model="postFrom.investmentAmount" placeholder="请输入您的投资" style="width:100%">
                    <el-option v-for="(item, index) in columns" :key="index" :label="item" :value="item"/>
                </el-select>
            </el-form-item>
            <el-form-item label="回访:">
                <el-date-picker
                    style="width:100%"
                    v-model="postFrom.visitTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="随时上班时间，随时下班时间">
                    </el-date-picker>
            </el-form-item>
            <el-form-item label="留言:">
                <el-input v-model="postFrom.message" placeholder="请填写留言或选择快捷留言"/>
            </el-form-item>
            <el-button type="primary" :disabled="btnStatus" style="width:100%" @click="submitMethod" :loading="loading">立即咨询</el-button>
        </el-form>
    </div>
</template>
<script>
export default {
    data () {
        const validatePhone = (rule, value, callback) => {
                    let reg = /^1[345789]\d{9}$/
                    if (value !== '' && reg.test(value)) {
                        callback()
                    } else {
                        callback(new Error('请输入正确的手机号'))
                    }
                }
        return {
            postFrom: {phone: ''},
            columns: ['0-5万', '5-10万', '10-30万', '30-100万', '100万以上'],
            rules: {
                username: [{ required: true, message: '姓名不可为空', trigger: 'change' }],
                phone: [{ required: true, message: '请输入正确的手机号', trigger: 'change', validator: validatePhone }]
            },
            loading: false,
            btnStatus: false
        }
    },
    methods: {
        submitMethod () {
            this.$refs.postForm.validate(async valid => {
                if (valid) {
                    this.loading = true
                    this.$http.post('https://api.hawksu.com/zykxapp/api-marketing/partner/save', this.postFrom).then(response => {
                        if (response.data.code === '1') {
                            this.postFrom = {}
                            this.btnStatus = true
                            this.$notify({
                                title: response.data.data + '',
                                type: 'success'
                            })
                        }
                        this.loading = false
                    }, response => {
                        console.log('error')
                    })
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .el-button--primary {
        background-color:#096EF1;
        border-color: #096EF1;
    }
    /deep/.el-input__inner {
        border-color: #096EF1;
    }
    /deep/.el-select .el-input.is-focus .el-input__inner {
        border-color: #096EF1 !important;
    }
    /deep/.el-select .el-input__inner:focus {
        border-color: #096EF1 !important;
    }
    .el-select-dropdown__item.selected {
        color: #343434;
    }
    /deep/.el-button--primary.is-disabled {
        border-color:#aaa;
        background-color:#aaa;
    }
</style>



// WEBPACK FOOTER //
// src/components/From.vue